module.exports = __webpack_public_path__ + "files/93fcabef1c00004ca99f85657983fba0.png";